<template>
  <div class="user-row">
    <div class="user">
      <router-link :to="route" class="name">{{ fullName }}</router-link>
      <div class="status" :class="statusClassList">{{ statusText }}</div>
    </div>
    <div class="contact">
      <div class="phone-number">
        <div class="label">เบอร์โทรศัพท์</div>
        <div class="value">{{ phoneNumber || "-" }}</div>
      </div>
      <div class="email">
        <div class="label">อีเมล</div>
        <div class="value">{{ email || "-" }}</div>
      </div>
    </div>
    <div class="home" v-if="home">
      <div class="header">บ้านหลัก</div>
      <div class="data">
        <div class="status">
          <div class="label">ฐานะ</div>
          <div class="value">{{ userRole }}</div>
        </div>
        <div class="address">
          <div class="label">บ้านเลขที่</div>
          <div class="value">{{ home.addressNumber }}</div>
        </div>
        <div class="project">
          <div class="label">โครงการ</div>
          <div class="value">{{ home.projectName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userRoleMapper } from "@/lib/mapper";

export default {
  props: [
    "route",
    "firstName",
    "lastName",
    "identifierId",
    "phoneNumber",
    "email",
    "isVerified",
    "home"
  ],
  computed: {
    fullName() {
      return `${this.firstName} ${this.lastName}`;
    },
    statusText() {
      if (!this.isVerified) {
        return "ยังไม่ยืนยันตัวตน";
      }

      return "ยืนยันตัวตนแล้ว";
    },
    statusClassList() {
      if (!this.isVerified) {
        return;
      }

      return "verified";
    },
    userRole() {
      if (!this.home) {
        return;
      }

      return userRoleMapper[this.home.userRole];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.name {
  font-weight: bold;
}

.contact,
.home {
  margin-top: 15px;
}

.contact {
  display: grid;
  grid-template-columns: 180px 120px auto;
  grid-gap: 15px;
}

.home > .data {
  display: grid;
  grid-template-columns: 120px 120px auto;
  grid-gap: 15px;
}

.label {
  color: #777;
  font-size: 0.9rem;
}

.user > .status {
  color: $danger-color;
  font-size: 0.9rem;
  font-weight: bold;

  &.verified {
    color: $success-color;
  }
}

.home > .header {
  font-size: 0.9rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/users/components/UserRow.vue